// extracted by mini-css-extract-plugin
export default {"euipo":"TrademarkOfficeBadge_euipo__tpPo2","dpma":"TrademarkOfficeBadge_dpma__FO2fP","default":"TrademarkOfficeBadge_default__becWg"};